import api from "./api";

// ================= WAREHOUSES =================
export async function getWarehouses() {
  const res = await api.get("/api/procurement/warehouses");
  return res.data?.warehouses || [];
}
export async function createWarehouse(payload) {
  const res = await api.post("/api/procurement/warehouses", payload);
  return res.data?.warehouse;
}
export async function updateWarehouse(id, payload) {
  const res = await api.put(`/api/procurement/warehouses/${id}`, payload);
  return res.data?.warehouse;
}
export async function deleteWarehouse(id) {
  const res = await api.delete(`/api/procurement/warehouses/${id}`);
  return res.data;
}

// ================= SUPPLIERS =================
// Suppliers are existing users with the 'vendor' role (added via User Management),
// not a separately created record — so there's no createSupplier here anymore.
export async function getSuppliers() {
  const res = await api.get("/api/procurement/suppliers");
  return res.data?.suppliers || [];
}

// ================= PURCHASE ORDERS =================
export async function getPurchaseOrders() {
  const res = await api.get("/api/procurement/purchase-orders");
  return res.data?.purchase_orders || [];
}
export async function getPurchaseOrderById(id) {
  const res = await api.get(`/api/procurement/purchase-orders/${id}`);
  return res.data?.purchase_order;
}
export async function createPurchaseOrder(payload) {
  const res = await api.post("/api/procurement/purchase-orders", payload);
  return res.data?.purchase_order;
}
